// hostname
export const domain = [
  "intlsos",
  "headlinealerts",
  "headlinealertss"  //for localhost
];

// isosLogo
import logo from '../assets/img/banner_v8.png';
export const isosLogo = logo;


// WEBPACK FOOTER //
// ./src/conf/config.js